"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _core = require("@emotion/core");

var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));

var _react = _interopRequireDefault(require("react"));

var _styles = require("@umich-lib/styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var StyledInput = ( /*#__PURE__*/0, _styledBase["default"])('input', {
  target: "e1o7tznz0",
  label: "StyledInput"
})("font-size:1rem;margin:0;border:solid 1px rgba(0,0,0,0.5);box-shadow:inset 0 1px 4px rgba(0,0,0,0.1);border-radius:4px;padding:0.5rem 0.75rem;width:100%;appearance:textfield;font-family:inherit;box-sizing:border-box;", function (_ref) {
  var invalid = _ref.invalid;
  return {
    borderColor: invalid && _styles.INTENT_COLORS.error,
    borderWidth: invalid && '2px'
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFJb0IiLCJmaWxlIjoiLi4vc3JjL2luZGV4LmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0IGZyb20gJ3JlYWN0J1xuaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuaW1wb3J0IHsgSU5URU5UX0NPTE9SUyB9IGZyb20gJ0B1bWljaC1saWIvc3R5bGVzJ1xuXG5jb25zdCBTdHlsZWRJbnB1dCA9IHN0eWxlZCgnaW5wdXQnKShcbiAge1xuICAgIGZvbnRTaXplOiAnMXJlbScsXG4gICAgbWFyZ2luOiAnMCcsXG4gICAgYm9yZGVyOiAnc29saWQgMXB4IHJnYmEoMCwwLDAsMC41KScsXG4gICAgYm94U2hhZG93OiAnaW5zZXQgMCAxcHggNHB4IHJnYmEoMCwwLDAsMC4xKScsXG4gICAgYm9yZGVyUmFkaXVzOiAnNHB4JyxcbiAgICBwYWRkaW5nOiAnMC41cmVtIDAuNzVyZW0nLFxuICAgIHdpZHRoOiAnMTAwJScsXG4gICAgYXBwZWFyYW5jZTogJ3RleHRmaWVsZCcsXG4gICAgZm9udEZhbWlseTogJ2luaGVyaXQnLFxuICAgIGJveFNpemluZzogJ2JvcmRlci1ib3gnXG4gIH0sXG4gICh7IGludmFsaWQgfSkgPT4gKHtcbiAgICBib3JkZXJDb2xvcjogaW52YWxpZCAmJiBJTlRFTlRfQ09MT1JTLmVycm9yLFxuICAgIGJvcmRlcldpZHRoOiBpbnZhbGlkICYmICcycHgnXG4gIH0pXG4pXG5cblxuZXhwb3J0IGRlZmF1bHQgKHtcbiAgY2xhc3NOYW1lLFxuICAuLi5vdGhlclxufSkgPT4gKFxuICA8U3R5bGVkSW5wdXQgY2xhc3NOYW1lPXtjbGFzc05hbWV9IHsuLi5vdGhlcn0gLz5cbikiXX0= */");

var _default = function _default(_ref2) {
  var className = _ref2.className,
      other = _objectWithoutProperties(_ref2, ["className"]);

  return (0, _core.jsx)(StyledInput, _extends({
    className: className
  }, other));
};

exports["default"] = _default;